import { EmailType } from '@/components/changePassword/type'
import { store } from '../../store/index'
import { Ref } from 'vue'

export const ChangePassword = (dataInput: Ref<EmailType>, errorRequred: Ref<boolean>) => {
    if(!dataInput.value.email) errorRequred.value = true
    else errorRequred.value = false
    if(dataInput.value.email && !errorRequred.value) store.dispatch('changePassword', dataInput.value)
}
